var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "gift-love-vibes.96c80a66.png","uri@2x": __webpack_public_path__ + "gift-love-vibes.afc37f5b.png","uri@3x": __webpack_public_path__ + "gift-love-vibes.324edee6.png",
    width: 72,
    height: 83
});